import { TENANT } from './tenantTypes'

export const LANGUAGE = {
  DE: 'de',
  FR: 'fr',
  IT: 'it',
  NL: 'nl',
} as const

export type LANGUAGE = (typeof LANGUAGE)[keyof typeof LANGUAGE]

export const tenantLanguagesConfig = {
  [TENANT.AT]: {
    defaultLanguage: LANGUAGE.DE,
    languages: [LANGUAGE.DE],
  },
  [TENANT.BE]: {
    defaultLanguage: LANGUAGE.NL,
    languages: [LANGUAGE.NL, LANGUAGE.FR],
  },
  [TENANT.CH]: {
    defaultLanguage: LANGUAGE.DE,
    languages: [LANGUAGE.DE, LANGUAGE.FR],
  },
  [TENANT.COM]: {
    defaultLanguage: LANGUAGE.DE,
    languages: [LANGUAGE.DE],
  },
  [TENANT.FR]: {
    defaultLanguage: LANGUAGE.FR,
    languages: [LANGUAGE.FR],
  },
  [TENANT.IT]: {
    defaultLanguage: LANGUAGE.IT,
    languages: [LANGUAGE.IT],
  },
} as const

export type TenantLanguagesConfig = typeof tenantLanguagesConfig

export type TenantLanguage = TenantLanguagesConfig[TENANT]['languages'][number]

/**
 * It's not possible to infer exact values as tenant is not known at current moment.
 * If you would like to get exact values for specific tenant access {@link tenantLanguagesConfig} directly.
 */
export const getTenantLanguages = (tenant: TENANT): TenantLanguage[] =>
  tenantLanguagesConfig[tenant].languages as unknown as TenantLanguage[]
